import React, { Component } from 'react';
import { PropTypes as PT } from 'prop-types';
import { injectIntl, FormattedMessage, defineMessages } from 'react-intl';
import _get from 'lodash/get';
import SVG from 'react-inlinesvg';
import shareScreenIcon from '@lifesize/ux-assets/vectors/svgIcons/share-screen.svg';
import Tooltip from 'components/Tooltip/Tooltip';
import classes from 'components/InCall/CallFooter.module.scss';
import { START_PRESENTATION_BUTTON, STOP_PRESENTATION_BUTTON } from 'constants/lsqaConstants';

const messages = defineMessages({
  shareScreen: {
    id: 'components.incall.controls.screenShare.tooltip.share',
    description: 'Default share screen tooltip',
    defaultMessage: 'Share your screen'
  },
  currentPresenter: {
    id: 'components.incall.controls.screenShare.tooltip.presenter',
    description: 'Name of current presenter',
    defaultMessage: '{name} is presenting'
  }
});

export class PresentationButton extends Component {

  handleScreenShareEvent = (e) => {
    const streamId = _get(e, 'data.streamId');
    if (streamId) {
      this.props.initiateScreenShare(streamId);
    }
  };

  inactivePresentationTooltip() {
    const { intl } = this.props;
    return this.props.presenterName ?
      intl.formatMessage(messages.currentPresenter, { name: this.props.presenterName }) :
      intl.formatMessage(messages.shareScreen);
  }

  render() {
    let button = null;
    if (this.props.isConnected) {
      if (this.props.isPresenting) {
        button = (
          <button
            className={classes.inCallButtonPresentationActive}
            onClick={this.props.onStopPresentationClick}
            {...STOP_PRESENTATION_BUTTON}
            data-testid="stop-presentation-btn"
          >
            <SVG src={shareScreenIcon} />
            <Tooltip
              location="top"
              style={{ bottom: '100%', marginBottom: 15 }} label={(
                <FormattedMessage
                  id="components.incall.controls.screenShare.tooltip.notShare"
                  defaultMessage="Stop sharing your screen"
                />
              )}
            />
          </button>
        );
      } else {
        button = (
          <button
            className={`${classes.inCallButton} ${this.props.isDisabled ? classes.disabled : ''}`}
            disabled={this.props.isDisabled}
            onClick={() => this.props.showPresentationSelection()}
            {...START_PRESENTATION_BUTTON}
            data-testid="start-presentation-btn"
          >
            <SVG src={shareScreenIcon} />
            <Tooltip
              location="top"
              style={{ bottom: '100%', marginBottom: 15 }} label={this.inactivePresentationTooltip()}
            />
          </button>
        );
      }
    }
    return button;
  }
}

PresentationButton.propTypes = {
  isConnected: PT.bool.isRequired,
  intl: PT.object,
  presenterName: PT.string,
  isPresenting: PT.bool.isRequired,
  isDisabled: PT.bool.isRequired,
  onStopPresentationClick: PT.func.isRequired,
  initiateScreenShare: PT.func,
  showPresentationSelection: PT.func.isRequired
};

export default injectIntl(PresentationButton);
